export const DOWNLOAD_LEADS_SENDING = 'DOWNLOAD_LEADS_SENDING';

export const DOWNLOAD_LEADS_SUCCESS = 'DOWNLOAD_LEADS_SUCCESS';

export const DOWNLOAD_LEADS_FAILED = 'DOWNLOAD_LEADS_FAILED';
